import urls from '../../urls';
import { redirectRoute } from '../helpers';
import SmartcardStore from '../../stores/SmartcardStore';
import UserStore from '../../stores/UserStore';
import { AccountPages, PointStages, AccountPagesForceLoginInsteadOfRedirect, GlobalModals } from '../../constants/AppConstants';
import CustomerActions from '../../actions/CustomerActions';
import ModalActions from '../../../src/actions/ModalActions';

export default {
    path: '/account',

    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/account/Layout').default);
        }, 'account-layout');
    },

    indexRoute: redirectRoute(null, AccountPages.ACCOUNT_DETAILS),

    getChildRoutes(location, cb) {
        require.ensure([], (require) => {
            cb(null, [
                require('./Details').default,
                require('./Addresses').default,
                require('./PreferenceCentre').default,
                require('./PhotocardsRailcards').default,
                require('./Payment').default,
                require('./Evouchers').default,
                require('./PurchaseHistory').default,
                require('./OrderDetails').default,
                require('./RefundDetails').default,
                require('./AmendDetails').default,
                require('./SmartcardApply').default,
                require('./SmartcardLink').default,
                require('./Smartcard/Transfer').default,
                require('./Smartcard').default,
                require('./Etickets').default,
                require('./STickets').default,
                require('./DisruptionAlerts').default,
                require('./LinkOrder').default,
                require('./FlexiSeason').default,
                require('./AutoDelayRepay').default,
                require('./OneClickDelayRepay').default,
                require('./passengerAssist/BookPassengerAssist').default,
                require('./passengerAssist/ViewBookedAssistance').default,
                require('./passengerAssist/AccessibilityProfile').default,
                require('./ConfirmExpiringSmartcard').default,
                require('./ConfirmSmartcardReplacement').default,
                require('./Reservations').default,
                require('./HistoricETickets').default,
            ].filter((x) => !!x));
        }, 'account-routes');
    },

    async onEnter (nextState, replace, callback) {
        const user = UserStore.getCurrent();
        const skipRedirect = AccountPagesForceLoginInsteadOfRedirect.includes(urls.resolve(nextState.location.pathname).name);
        if (!skipRedirect && (!user || !user.isLoggedIn())) {
            replace(urls.location(PointStages.SEARCH));
            ModalActions.open(GlobalModals.LOGIN, {initialPath: nextState.location.pathname});
        }

        //Load smartcards first, as the account pages expect them to be loaded
        if (!SmartcardStore.getCurrent()) {
            const smartcard = await CustomerActions.getSmartcard(user);
            if (smartcard) {
                await CustomerActions.getAllSmartcards(user);
            }
        }
        callback();
    }
};
